import { mount } from '@kitup/web-core';
import { createEn } from '@kitup/web-core/i18n/en';
import { brand } from '@kitup/brand-talearoo';
import { legal } from '@kitup/brand-talearoo/legal';
import { storefront } from '@kitup/brand-talearoo/storefront';

/**
 * TaleAroo is English-only. The Russian dictionary is not imported here and
 * therefore never lands in the bundle.
 */
mount(brand, legal, storefront, { en: createEn });
